import styled from 'styled-components/macro';
import * as colors from '../../../../../common/colorConstants';
import { TextInput } from '../../../../../common/formElements';

export const FormContainer = styled.div`
  padding: 18px 30px 30px;
  flex-grow: 1;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
`;

export const Label = styled.label`
  width: 115px;
  margin-bottom: 0;
  font-family: 'Roboto', sans-serif;
  font-size: 11px;
  font-weight: 400;
  color: ${colors.black4};
`;

export const Input = styled(TextInput)`
  padding: 4px 8px;
  width: 250px;
  font-family: 'Roboto', sans-serif;
  font-size: 11px;
  font-weight: 500;
`;
